import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isSubmitting, isValid, submit } from 'redux-form';

import Button from '@material-ui/core/Button';

import Form from './AccountReduxForm';

import { FORM_NAME } from './index';
import { setAccountData } from '../../../redux/account';

import PageBase from '../../../app/PageBase';

const mapStateToProps = state => ({
  submitting: isSubmitting(FORM_NAME)(state),
  valid: isValid(FORM_NAME)(state),
  accountId: state.accountReducer.accountId,
  open: state.accountReducer.open,
  accountData: state.accountReducer.accountData,

});
const mapDispatchToProps = {
  submit,
  setAccountData,
};

class AccountForm extends Component {

  static propTypes = {
    onClose: PropTypes.func,
  };

  static defaultProps = {
    onClose: () => console.log('create!'),
  };

  submit = () => this.props.submit(FORM_NAME);

  close = () => this.props.history.push('/account/list/');


  render() {

    const {
      open, accountId, accountData, submitting, valid, consultMode,
    } = this.props;

    const dialogActions = [
      <Button
        label={I18n.t('application.close')}
        onTouchTap={this.close}
        disabled={submitting}
      />,
      <Button
        label={I18n.t('application.save')}
        primary
        keyboardFocused
        onTouchTap={this.submit}
        disabled={submitting || !valid}
      />,
    ];


    let title = accountId ? I18n.t('titles.edit') : I18n.t('titles.create');
    title += I18n.t('titles.account');
    return (


      <PageBase
        title={title}
        showSaveButton
        handleCloseClick={this.close}
        handleSaveClick={this.submit}
        disableSaveButton={submitting || !valid}
      >
        <Form
          id={accountId}
          onSubmitSuccess={this.close}
        />

      </PageBase>


    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountForm));




// WEBPACK FOOTER //
// ./src/components/tracker/User/AccountForm.js